import { Prototype } from '@core';
// import { useFetchDashboardAllocationMessages } from '@hooks';
import React, { memo } from 'react';
import { KContainer } from 'uikit';

import Reports from './Allocation.Reports';
// import { useDashboardAllocation } from '../../helpers';
const NOW = Prototype.date.now();
const Allocation = () => {
  return (
    <KContainer.View marginT={0} dp="flex">
      <KContainer.View dp="flex" flex overflow>
        <Reports date={Prototype.date.formatDB(NOW)} />
      </KContainer.View>
    </KContainer.View>
  );
};

export default memo(Allocation);
